import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ITaxLetterResponse } from './useTaxLetterMutation';

export interface ITaxLetterBatchRequest {
	templateId: string;
	contactIds: string[];
	startDate?: string;
	endDate?: string;
	signatureTemplateId?: string;
}

export const useTaxLetterBatchMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: ITaxLetterResponse) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			request,
			impersonationContext,
		}: {
			request: ITaxLetterBatchRequest;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<ITaxLetterResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'donation/taxLetter/batch',
				}),
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
};
